import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
} from "@chakra-ui/modal";
import { useDisclosure } from "@chakra-ui/hooks";
import Card from "components/card";

const ConfirmButtom = ({ onConfirm, message, className, children }) => {

    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <>
            <button onClick={() => onOpen()} className={className}>
                {children}
            </button>
            <Modal isOpen={isOpen} className="!z-[1010]" motionPreset="slideInBottom">
                <ModalOverlay className="bg-[#000] !opacity-40 backdrop-blur-sm" />
                <ModalContent className="!z-[1002] !m-auto !w-max min-w-[250px] !max-w-[700px] md:top-[15vh]">
                    <ModalBody>
                        <Card extra="rounded-[20px] shadow-2xl">
                            <div className="ml-[18px] flex h-[90px] w-[100%] flex-row items-center">
                                <h2 className="text-2xl font-bold text-navy-700 dark:text-white">Confirmación</h2>
                            </div>
                            <div className="rounded-lg ml-5 mr-5 mb-5 w-[400px] ">
                                <div>
                                    {message || '¿Estás seguro de realizar esta acción?'}
                                </div>
                            </div>
                            <div className="ml-[18px] mb-[20px] mr-[20px] grid grid-cols-2">
                                <div><button type="button" onClick={onClose} className="rounded-lg border-2 border-red-50 p-2 font-medium text-red-500 transition-all duration-200 hover:-translate-y-0.5 hover:bg-red-600 hover:text-white hover:shadow-md active:translate-y-0 active:bg-red-700 dark:bg-red-400 dark:text-white dark:hover:bg-red-300 dark:active:bg-red-200">
                                    Cancelar
                                </button></div>
                                <div className="text-end">
                                    <button type="button" onClick={() => { onConfirm(); onClose(); }} className="rounded-lg bg-green-500 p-2 font-medium text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-green-600 hover:shadow-md active:translate-y-0 active:bg-green-700 dark:bg-green-400 dark:text-white dark:hover:bg-green-300 dark:active:bg-green-200">
                                        Si, seguro
                                    </button>
                                </div>
                            </div>
                        </Card>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}

export default ConfirmButtom;